import { Trans } from "react-i18next";
import { Text } from "@chakra-ui/react";
import { getAppValue } from "src/utils/environment";
import Step from "./components/Step";

export const steps = [
  {
    id: "first",
    Component: ({ flow }) => (
      <Step
        animationName="onboarding-step-1.json"
        onClick={() => flow.next()}
        flow={flow}
        mediaProps={{
          height: getAppValue({ bibino: "198px", barkio: "161px" }),
          width: getAppValue({ bibino: "216px", barkio: "222px" })
        }}
        heading={
          <Trans
            i18nKey="newOnboarding.page1.title"
            components={{
              color: (
                <Text as="span" color="primary">
                  monitor
                </Text>
              )
            }}
          />
        }
        subtitle="newOnboarding.page1.subtitle"
        noteKey="newOnboarding.page1.note"
        buttonStringKey="buttons.getStarted"
      />
    )
  },
  {
    id: "second",
    Component: ({ flow, flowState }) => (
      <Step
        imageName="useCase.svg"
        flow={flow}
        mediaProps={{
          height: getAppValue({ bibino: "160px", barkio: "178px" }),
          width: getAppValue({ bibino: "200px", barkio: "222px" })
        }}
        heading={
          <Trans
            i18nKey={"newOnboarding.page2.title"}
            components={{
              color: (
                <Text as="span" color="primary">
                  Two devices
                </Text>
              )
            }}
          />
        }
        onClick={flowState.finish}
        subtitle="newOnboarding.page2.subtitle"
        Note={
          <Trans
            i18nKey="newOnboarding.page2.note"
            components={{
              b: <span style={{ fontWeight: "bold" }} />
            }}
          />
        }
        buttonStringKey="buttons.continue"
      />
    )
  }
];
